/**
 * Set Webpack public path for chunk loading (lazy-loaded routes, etc.).
 * Must be the first import in index.js so chunk URLs include the base path.
 * When served at /us/cars/, chunks must load from /us/cars/static/js/... not /static/js/...
 */
/* global __webpack_public_path__:writable */
if (typeof __webpack_public_path__ !== 'undefined') {
  const base = (typeof window !== 'undefined' && window.__BASE_PATH__) || '';
  __webpack_public_path__ = base ? (base.endsWith('/') ? base : base + '/') : '/';
}
